var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.item_video.video.src)?_c('VideoJs',{staticClass:"full-height width-100",attrs:{"item":_vm.item_video,"id":_vm.item.bulletin_number + _vm.t,"controls":true,"custom":true,"pause":_vm.is_pause,"play":_vm.is_play,"is_video":false,"is_auto":false,"is_sample":_vm.is_sample}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }